import { ASSETS_URL, ReviewProduct, ReviewType, VideoReview } from '../../types';
import subs from '@/static/assets/reviews/DennisWright_Pet/subs.vtt';
import poster from '@/static/assets/reviews/DennisWright_Pet/video.jpg';

export const DennisWright: VideoReview = {
  type: ReviewType.Video,
  product: [ReviewProduct.Pet, ReviewProduct.All],
  reviewerName: 'Dennis',
  videoUrl: `${ASSETS_URL}/pet/DennisWright_Pet.webm`,
  posterUrl: poster,
  captionsUrl: subs,
  displayInHomePage: true,
};
